import React, { FC, FormEvent, useState } from 'react';
import { LoadingAnimation } from '../../../../LoadingAnimation/LoadingAnimation';

import { Textarea } from '../../../Partials/Textarea';
import { InsuranceFormSubmissionStatus } from '../../../Utils/types';
import { FormControls } from '../../FormControls';
import { useInsuranceLabels } from '../../../Utils/Context/labelsContext';
import { useInsuranceReportErrorForm, InsuranceReportErrorFormFields } from '../Utils/reportErrorForm';
import { FormSubmittedStatus } from '../../FormSubmittedStatus';
import { ContactApi } from '../../../../Api/ContactApi';

export const ReportErrorForm: FC = () => {
  const { state, dispatch } = useInsuranceReportErrorForm();
  const [formSubmissionStatus, setFormSubmissionStatus] = useState<InsuranceFormSubmissionStatus>('initial');
  const contactApi = new ContactApi();

  const {
    buttons,
    headings,
    labels,
    inputs
  } = useInsuranceLabels();

  const SubmissionLabel = () =>
    <span>
      {buttons.reportErrorSubmitButtonLabel}
      <span className="contactForm__loading">
        {formSubmissionStatus === "loading" && (
          <LoadingAnimation className="contactForm__loadingItem" />
        )}
      </span>
    </span>

  const dispatchValue = <T extends {}>(field: InsuranceReportErrorFormFields, value: T) =>
    dispatch({
      field,
      type: 'update',
      payload: value
    })

  const submitForm = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (formSubmissionStatus === 'loading') return;
    setFormSubmissionStatus('loading')
    try {
      await contactApi.sendErrorMail(state);
      setFormSubmissionStatus('success');
    } catch (error) {
      setFormSubmissionStatus('error');
    }
  }

  const onSubmitClick = () => {
    dispatch({
      field: 'submitted',
      type: 'update',
      payload: true
    })
  }

  return (
    <form
      onSubmit={submitForm}
      className="contactForm__form"
      name="InsuranceReportErrorForm"
    >
      <div className="contactForm__formDescription">
        <p className="contactForm__formDescriptionHeader">{headings.reportErrorHeading}</p>
        <span className="contactForm__formDescriptionSubHeader">{headings.reportErrorSubHeading}</span>
      </div>
      <div className="contactForm__formInputs">
        <Textarea
          name="message"
          label={inputs.reportErrorLabel}
          hideLabel
          onValueChange={(value) => dispatchValue<string>('message', value)}
          placeholder={inputs.reportErrorPlaceholder}
          backgroundVariant="blue-light"
          error={
            state.submitted && state.message.length === 0
              ? inputs.requiredLabel
              : undefined
          }
          required
        />
      </div>
      {(formSubmissionStatus === 'initial' || formSubmissionStatus === 'loading') && (
        <FormControls
          onSubmit={onSubmitClick}
          submitButtonLabel={<SubmissionLabel />}
          discardButtonIcon="s-close-with-padding"
          submitButtonIcon="s-arrow-right-dash-with-padding"
          buttonsSize="xlarge"
        />
      )}
      {(formSubmissionStatus === 'success' || formSubmissionStatus === 'error') && (
        <FormSubmittedStatus
          status={formSubmissionStatus}
          successMessage={labels.reportErrorSubmissionSuccess}
          errorMessage={labels.reportErrorSubmissionError}
        />
      )}
    </form>
  )
};
